module.exports = __webpack_public_path__ + "img/ac5.b0053e00.jpg";